module.exports = __webpack_public_path__ + "components/panel/static/affiliate_snow-holidays-59529559062ea4d5e4798a291737bf02.webp";